export const organizationCenterPhrases = Object.freeze({
    title: 'Organizations',
    description: 'Create and manage the organizations you belong to.',
    create: 'Create organization',
    create_title: 'Create a new organization',
    name: 'Organization name',
    avatar: 'Organization avatar',
    avatar_removed: 'Organization avatar removed.',
    description_label: 'Description',
    empty: 'You do not belong to an organization yet.',
    pending_invitations: 'Pending invitations',
    accept: 'Accept',
    decline: 'Decline',
    owner: 'Owner',
    tabs: {
        overview: 'Overview',
        members: 'Members',
        invitations: 'Invitations',
        roles: 'Management roles',
        branding: 'Branding',
        security: 'Security',
        jit: 'JIT provisioning',
        applications: 'Shared resources',
        activity: 'Activity',
        deletion: 'Delete',
    },
    members: {
        title: 'Members',
        empty: 'No members found.',
        remove: 'Remove',
        removed: 'Member removed.',
        business_roles: 'Business roles',
        no_business_roles: 'No business roles are available. Ask your tenant administrator to share roles with this organization.',
    },
    invitations: {
        title: 'Invitations',
        invite: 'Invite member',
        email: 'Email address',
        empty: 'No invitations found.',
        resend: 'Resend',
        resent: 'Invitation resent.',
        revoke: 'Revoke',
        revoked: 'Invitation revoked.',
        status: {
            Pending: 'Pending',
            Accepted: 'Accepted',
            Expired: 'Expired',
            Revoked: 'Revoked',
            Declined: 'Declined',
        },
    },
    roles: {
        title: 'Management roles',
        create: 'Create role',
        permissions: 'Permissions',
        empty: 'No management roles found.',
        select_member: 'Select member',
        select_role: 'Select role',
        assign: 'Assign role',
        assigned: 'Role assigned.',
        unassign: 'Remove role',
        unassigned: 'Role removed.',
        permission_count: 'Permissions: {{count}}',
        built_in: {
            owner: 'Owner',
            owner_description: 'Organization owners have exclusive control over ownership and deletion.',
            administrator: 'Administrator',
            administrator_description: 'Manage the organization except for actions reserved for owners.',
        },
        permission_labels: {
            update_profile: 'Update profile',
            manage_branding: 'Manage branding',
            view_members: 'View members',
            manage_members: 'Manage members',
            manage_invitations: 'Manage invitations',
            assign_business_roles: 'Assign business roles',
            manage_management_roles: 'Manage management roles',
            assign_management_roles: 'Assign management roles',
            manage_security: 'Manage security',
            manage_jit: 'Manage JIT provisioning',
            manage_applications: 'Manage applications',
            view_activity: 'View activity',
        },
    },
    branding: {
        title: 'Organization branding',
        primary_color: 'Primary color',
        custom_css: 'Custom CSS',
        preview: 'Preview',
        light: 'Light',
        dark: 'Dark',
    },
    security: {
        title: 'Organization security',
        require_mfa: 'Require multi-factor authentication for members',
    },
    jit: {
        title: 'JIT email domains',
        domain: 'Email domain',
        add: 'Add domain',
        verify: 'Check DNS',
        dns_instruction: 'Create TXT {{record}} with value {{value}}.',
        verified: 'Verified',
    },
    applications: {
        title: 'Shared resources',
        empty: 'No resources are available for this organization.',
        sso: 'Enterprise SSO connections',
        m2m: 'Machine-to-machine applications',
    },
    activity: {
        title: 'Organization activity',
        empty: 'No activity yet.',
        events: {
            create: 'Organization created',
            delete: 'Organization deleted',
            profile: 'Organization profile updated',
            branding: 'Organization branding updated',
            security: 'Organization security updated',
            member_add: 'Member added',
            member_remove: 'Member removed',
            owner: 'Organization ownership updated',
            role_create: 'Management role created',
            role_update: 'Management role updated',
            role_delete: 'Management role deleted',
            role_assign: 'Management role assigned',
            role_unassign: 'Management role removed from member',
            business_role: 'Business roles updated',
            invitation_create: 'Invitation sent',
            invitation_accept: 'Invitation accepted',
            invitation_decline: 'Invitation declined',
            invitation_revoke: 'Invitation revoked',
            jit: 'JIT provisioning updated',
            domain: 'Email domain verification',
            application: 'Application connections updated',
            unknown: 'Organization activity',
        },
    },
    save: 'Save changes',
    cancel: 'Cancel',
    delete: 'Delete organization',
    delete_confirmation: 'This permanently deletes the organization and its memberships. Enter “{{name}}” to confirm.',
    deleted: 'Organization deleted.',
    load_failed: 'Could not load organization data. Try again.',
    permission_denied: 'You do not have permission to view this section.',
});
export const withOrganizationCenter = (accountCenter, organizationPhrases = organizationCenterPhrases) => ({
    ...accountCenter,
    page: {
        ...accountCenter.page,
        sidebar_organizations: organizationPhrases.title,
    },
    organizations: organizationPhrases,
});
